import Config from '../config/env'

// @ts-ignore Ignore is required for custom server with different ts compile options
export const isServer = () => !process.browser

// True only for local development(when server is launched with 'yarn dev')
export const isDevelopment = () => process.env.NODE_ENV === 'development'

// Env detections utils
export const isDevEnvironment = () => Config.ENVIRONMENT === 'dev'

export const isIntEnvironment = () => Config.ENVIRONMENT === 'int'

export const isPrdEnvironment = () => Config.ENVIRONMENT === 'prd'
